import clsx from "clsx";
import { useEffect, useState } from "react";
import { useBankAccount } from "contexts/v1/pages/BankAccountContext";

const BankAccountCreate = ({ initialData, onSuccess, onError }) => {
    const { createBankAccount, updateBankAccount } = useBankAccount();

    const [bankAccount, setBankAccount] = useState({
        form: {
            bank_name: initialData?.bank_name || "",
            bank_account: initialData?.bank_account || "",
            bank_number: initialData?.bank_number || ""
        },
        error: {},
        isSubmitting: false,
        isUpdateMode: !!initialData,
    });

    const handleInputChange = (field, value) => {
        setBankAccount((prevState) => ({
            ...prevState,
            form: { ...prevState.form, [field]: value },
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBankAccount((prevState) => ({ ...prevState, isSubmitting: true }));
        try {
            const response = await createBankAccount(bankAccount.form);
            if (response.success) {
                onSuccess?.(response);
            } else {
                setBankAccount((prevState) => ({ ...prevState, error: response.error }));
                onError?.(response);
            }
        } catch (error) {
            onError?.(error);
        } finally {
            setBankAccount((prevState) => ({ ...prevState, isSubmitting: false }));
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setBankAccount((prevState) => ({ ...prevState, isSubmitting: true }));
        try {
            const response = await updateBankAccount(initialData.id, bankAccount.form);
            if (response.success) {
                onSuccess?.(response);
            } else {
                setBankAccount((prevState) => ({ ...prevState, error: response.error }));
                onError?.(response);
            }
        } catch (error) {
            onError?.(error);
        } finally {
            setBankAccount((prevState) => ({ ...prevState, isSubmitting: false }));
        }
    };

    useEffect(() => {
        if (initialData) {
            setBankAccount((prevState) => ({
                ...prevState,
                form: {
                    bank_name: initialData.bank_name,
                    bank_account: initialData.bank_account,
                    bank_number: initialData.bank_number
                },
            }));
        }
    }, [initialData]);

    return (
        <form onSubmit={bankAccount.isUpdateMode ? handleUpdate : handleSubmit} className="d-flex flex-column" style={{ height: "100%" }}>
            <div className="action-sheet-content flex-grow-1">
                {/* Bank Name Field */}
                <div className="row mb-3 align-items-center">
                    <label htmlFor="bank_name" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: "14px" }}>
                        Bank Name:
                    </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", bankAccount.error?.bank_name && "is-invalid")}
                            id="bank_name"
                            placeholder="Bank Name"
                            value={bankAccount.form.bank_name}
                            onChange={(e) => handleInputChange("bank_name", e.target.value)}
                            disabled={bankAccount.isSubmitting}
                            style={{ fontSize: "14px", height: "35px" }}
                        />
                        {bankAccount.error?.bank_name && <div className="invalid-feedback">{bankAccount.error.bank_name}</div>}
                    </div>
                </div>

                {/* Bank Account Field */}
                <div className="row mb-3 align-items-center">
                    <label htmlFor="bank_account" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: "14px" }}>
                        Bank Account:
                    </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", bankAccount.error?.bank_account && "is-invalid")}
                            id="bank_account"
                            placeholder="Bank Account"
                            value={bankAccount.form.bank_account}
                            onChange={(e) => handleInputChange("bank_account", e.target.value)}
                            disabled={bankAccount.isSubmitting}
                            style={{ fontSize: "14px", height: "35px" }}
                        />
                        {bankAccount.error?.bank_account && <div className="invalid-feedback">{bankAccount.error.bank_account}</div>}
                    </div>
                </div>

                {/* Bank Number Field */}
                <div className="row mb-3 align-items-center">
                    <label htmlFor="bank_number" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: "14px" }}>
                        Bank Number:
                    </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", bankAccount.error?.bank_number && "is-invalid")}
                            id="bank_number"
                            placeholder="Bank Number"
                            value={bankAccount.form.bank_number}
                            onChange={(e) => handleInputChange("bank_number", e.target.value)}
                            disabled={bankAccount.isSubmitting}
                            style={{ fontSize: "14px", height: "35px" }}
                        />
                        {bankAccount.error?.bank_number && <div className="invalid-feedback">{bankAccount.error.bank_number}</div>}
                    </div>
                </div>
            </div>

            {/* Submit Button */}
            <div className="form-group mt-auto d-grid">
                <button type="submit" className="btn btn-primary btn-block" disabled={bankAccount.isSubmitting}>
                    {bankAccount.isUpdateMode ? "Update Bank Account" : "Create Bank Account"}
                </button>
            </div>
        </form>
    );
};

export default BankAccountCreate;
